import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import axios from "axios";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import {
  deleteSmsTemplateAction,
  getSmsTemplateAction,
  sendSmsTemplateAction,
  sendSmsTemplateResponseAction,
  setAddSmsTemplateResponse,
  setDeleteSmsTemplateSuccessAction,
  setSmsTemplateAction,
  setUpdateSmsTemplateAction,
  updateSmsTemplateAction,
} from "../reducers/smsTemplateSlice";
import { addSmsTemplateAction } from "../reducers/emailTemplateSlice";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getSmsTemplateSaga(): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const temp = yield call<any>(callAPI, {}, "get", "client/preset/sms");
    console.log("temp-", temp);
    if (temp?.data) {
      yield put(setSmsTemplateAction(temp?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
  }
  yield put(setLoaderAction(false));
}

function* addSmsTemplateSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      "client/preset/sms"
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddSmsTemplateResponse(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    yield put(setAddSmsTemplateResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* updateSmsTemplateSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    console.log("payload", payload);
    const templateId = payload?.payload?.template_id;
    const { template_id, created_at, updated_at, ...templateData } =
      payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      { payload: templateData },
      "put",
      `client/preset/sms/${templateId}`
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUpdateSmsTemplateAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    yield put(setUpdateSmsTemplateAction(false));
  }
  yield put(setLoaderAction(false));
}

function* deleteSmsTemplateSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    console.log("action", action?.payload);
    const Id = action.payload?.template_id; // Directly access the payload
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `client/preset/sms/${Id}`
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setDeleteSmsTemplateSuccessAction(true));
      yield put(getSmsTemplateAction());
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    yield put(setDeleteSmsTemplateSuccessAction(false));
  }
  yield put(setLoaderAction(false));
}

function* sendSmsTemplateSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
   const {
    disclaimer,
    event,
    links,
    placeholders,
    signature,
    signature_option,
    template_id,
    body,
    template_name,
    ...newPayload
  } = payload?.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "post",
      "client/preset/send-sms"
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(sendSmsTemplateResponseAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    yield put(sendSmsTemplateResponseAction(false));
  }
  yield put(setLoaderAction(false));
}

export function* watchSmsTemplate() {
  yield takeLatest<any>(getSmsTemplateAction, getSmsTemplateSaga);
  yield takeLatest<any>(addSmsTemplateAction, addSmsTemplateSaga);
  yield takeLatest<any>(updateSmsTemplateAction, updateSmsTemplateSaga);
  yield takeLatest<any>(deleteSmsTemplateAction, deleteSmsTemplateSaga);
  yield takeLatest<any>(sendSmsTemplateAction, sendSmsTemplateSaga);
}
